import { memo } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { USER_TYPE } from '../../constants/copy';
import { PERMISSIONS } from '../../constants/permissions';
import { usePermission } from '../../hooks/usePermission';

const TARGET_TYPE = { makeAdmin: USER_TYPE.ADMIN, makeMember: USER_TYPE.MEMBER };

/**
 * Inline action of the USER TYPE field: Make Admin on a Member, Make Member on an Admin.
 * Renders nothing for an Owner (`action` is null) or for an actor who may not change a user type
 * (`MEMBERS_CHANGE_USER_TYPE`: the Owner by default, see `ADMIN_CAN_CHANGE_USER_TYPE`).
 *
 * @param {object} props
 * @param {'makeAdmin'|'makeMember'|null} props.action From `getMemberActions().userTypeAction`.
 * @param {(userType: string) => void} props.onRequest Called with the target user type.
 */
function ChangeUserTypeAction({ action, onRequest }) {
  const { t } = useTranslation('people-access');
  const { allowed } = usePermission(PERMISSIONS.MEMBERS_CHANGE_USER_TYPE);
  if (!action || !allowed) return null;
  return (
    <Button variant="tertiary" size="sm" onClick={() => onRequest(TARGET_TYPE[action])}>
      {t(`memberDetail.${action}`)}
    </Button>
  );
}

export default memo(ChangeUserTypeAction);
